// eslint-disable-next-line
export const passedStoredTimeout = (storageName, timeoutMs) => {
  const dateClosed = JSON.parse(localStorage.getItem(storageName)) || 0;

  return Date.now() - dateClosed >= timeoutMs;
};
